import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import 'react';
import { requestFailCallback } from '../../utils/serviceUtil.js';
import '../../utils/ErrorProvider.js';
import '../../utils/LoaderProvider.js';
import '../../utils/RefetchProvider.js';
import '../../utils/NotificationProvider.js';
import 'tslib';
import '../../utils/ContactProvider.js';
import '../../utils/PolicyProvider.js';
import '../../utils/AnalyticsProvider.js';
import { requestSuccessCallbackV3, responseSuccessCallbackV3, responseFailCallbackV3 } from '../../utils/serviceUtilv3.js';
import '../../types/AccessDevice.js';
import '../../types/Analytics.js';
import '../../types/CASACommunity.js';
import '../../types/Community.js';
import '../../types/DxSettings.js';
import '../../types/MagicButton.js';
import '../../types/Pannellum.js';
import '../../types/Prospect.js';
import '../../types/ProspectIntelligence.js';
import '../../types/Space.js';
import '../../types/Tour.js';
import '../../utils/analyticsPlugin.js';
import '../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../utils/cookieUtils.js';
import '../../utils/termsConditionsAgreementsUtils.js';
import { setupCache, setup } from 'axios-cache-adapter';
import * as localforage from 'localforage';

const ANALYTICS_DB_NAME = "peek-analytics";
const MAX_AGE = 3 * 60 * 60 * 1000; // 3 hours
const storageInstance = localforage.createInstance({
    driver: localforage.INDEXEDDB,
    name: ANALYTICS_DB_NAME,
    storeName: "analytics-cache",
});
const cacheAdapter = setupCache({
    maxAge: MAX_AGE,
    store: storageInstance,
    exclude: {
        query: false,
    },
});
const analyticsV2BaseService = setup({
    baseURL: `${process.env.PEEK_APP_API_URL}analytics/v2/`,
    cache: cacheAdapter,
});
analyticsV2BaseService.defaults.headers.common["Content-Type"] = "application/json";
// Add a request interceptor
analyticsV2BaseService.interceptors.request.use(requestSuccessCallbackV3, requestFailCallback);
// Add a response interceptor
analyticsV2BaseService.interceptors.response.use(responseSuccessCallbackV3, responseFailCallbackV3);

export { ANALYTICS_DB_NAME, analyticsV2BaseService as default };
